import { DynamicStandaloneImage, DynamicStandaloneImageProps } from '@/components/Image';
import { componentTheme } from '@/styles/ArticleTeaserDefault';
import { StandaloneComponent } from '@/types/component';
import mergeProps from 'lib/utils/mergeProps';

export type ArticleTeaserImageProps = DynamicStandaloneImageProps;

export const ArticleTeaserImageComponent: StandaloneComponent<ArticleTeaserImageProps> = (props) => {
  return (
    <DynamicStandaloneImage
      {...mergeProps(
        {
          options: {
            fill: true,
            theme: componentTheme('image'),
          },
        },
        props
      )}
    />
  );
};
